<template>
  <div>
    <div class="header">
      <div class="logo">江苏政务服务</div>
      <div class="header-right">
        <p @click="logOut">退出登录</p>
        <!-- <p>登录</p>
        <span>/</span>
        <p>注册</p> -->
      </div>
    </div>
    <div class="banner">
      <img src="@/assets/img/banner2.png" alt="">
    </div>
  </div>
</template>

<script>
import {validateTicket} from "@/api/zwfwLogin";
import {Base64} from 'js-base64';

export default {
  components: {},
  data() {
    return {
      ticket: '',
      gotoUrl: '',
    };
  },
  computed: {},
  watch: {},
  methods: {
    toMore() {
      this.$router.push({
        // path:'/more'
        path: "/",
      });
    },
    logOut(){
      var a=Base64.encode('https://www.jszwfw.gov.cn/jsjis/front/login.do?uuid=Qc2DWxfKJaLI');
      window.sessionStorage.clear()
      window.localStorage.clear()
      // 跳转到登录页
      window.location.href='https://www.jszwfw.gov.cn/jszwfw/member/otherLogin/logout.do?gotourl='+a;
      // this.$router.replace('https://www.jszwfw.gov.cn/jsjis/front/login.do?uuid=Qc2DWxfKJaLI');
    }
  },
  created() {
	  // let form = sessionStorage.getItem("peopleData");
	  // console.log("peopleData", form)
	  // if (form != null && form != undefined && form != "") {
	  // } else {
		//   var query = this.$route.query;
		//   console.log("query", query)
		//   this.ticket = query.ticket;
		//   console.log("ticket", this.ticket)
		//   // this.gotoUrl = query.gotoUrl;
		//   if (this.ticket != "" && this.ticket != undefined) {
		// 	  let param = {ticket: this.ticket}
		// 	  validateTicket(param).then((response) => {
		// 		  console.log("-----23", response)
		// 		  sessionStorage.setItem("peopleData", JSON.stringify(response.data));
		// 	  })
		//   } else {
		// 	  this.logOut();
		//   }
	  // }
  },
  mounted() {

  },
};
</script>
<style lang="scss" scoped>
.header {
  background: #fff;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 215px;
  .logo{
    color: #333333;
    font-size: 30px;
    font-family: HYDaHeiJ;
  }
  .header-right{
    color: #666666;
    font-size: 16px;
    display: flex;
    align-items: flex-end;
    p{
      cursor: pointer;
    }
    span{
      margin: 0 5px;
    }
  }
}
</style>
